import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authService } from "@/api/services";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await authService.forgotPassword(email);
            setSent(true);
            toast.success("If that email exists, a reset link has been sent");
        } catch (err) {
            toast.error(err?.message || "Failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Layout withFooter={false}>
            <Seo title="Forgot Password" path="/forgot-password" noIndex />
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
                <div className="w-full max-w-md">
                    <h1 className="text-3xl font-black uppercase tracking-tighter text-center mb-6">
                        Forgot password
                    </h1>
                    {sent ? (
                        <div className="bg-card border border-border p-8 text-center space-y-3">
                            <p className="text-zinc-200">
                                If that email is registered, we've sent you a reset link.
                            </p>
                            <Link to="/login" className="text-primary font-mono text-xs uppercase tracking-widest">
                                Back to login →
                            </Link>
                        </div>
                    ) : (
                        <form
                            onSubmit={onSubmit}
                            className="bg-card border border-border p-8 space-y-5"
                            data-testid="forgot-form"
                        >
                            <div className="space-y-2">
                                <Label htmlFor="email" className="font-mono text-xs uppercase tracking-widest text-zinc-400">
                                    Email
                                </Label>
                                <Input
                                    id="email"
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="rounded-none bg-background border-border focus:border-primary focus:ring-1 focus:ring-primary"
                                    data-testid="forgot-email-input"
                                />
                            </div>
                            <Button
                                type="submit"
                                disabled={submitting}
                                className="w-full rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider h-11"
                                data-testid="forgot-submit-btn"
                            >
                                {submitting ? "Sending..." : "Send reset link"}
                            </Button>
                        </form>
                    )}
                </div>
            </div>
        </Layout>
    );
}
